export const TOUR_STEPS = [
  {
    target: 'body',
    title: 'Welcome to omniO!',
    content:
      'Let us give you a quick tour of the platform so you know exactly where everything is.',
    placement: 'center',
    disableBeacon: true,
  },
  {
    target: '[data-tour="sidebar-nav"]',
    title: 'Navigation Sidebar',
    content:
      'This is your main navigation. Use it to switch between all the different intelligence hubs on the platform.',
    placement: 'right',
    disableBeacon: true,
  },
  {
    target: '[data-tour="sidebar-brand-intel"]',
    title: 'Brand & Market Intel Hub',
    content:
      'Track brands, monitor sentiment trends, and compare competitors across Instagram, TikTok, YouTube and more.',
    placement: 'right',
    disableBeacon: true,
  },
  {
    target: '[data-tour="sidebar-linkedin"]',
    title: 'LinkedIn Intel Hub',
    content:
      'Get deep insights from LinkedIn public pages and your own connected accounts.',
    placement: 'right',
    disableBeacon: true,
  },
  {
    target: '[data-tour="sidebar-leadgen"]',
    title: 'Lead Generation Insights',
    content:
      'Find sales leads, social media leads, and job insights — all powered by social data.',
    placement: 'right',
    disableBeacon: true,
  },
  {
    target: '[data-tour="search-bar"]',
    title: 'Search & Filters',
    content:
      'Enter a brand name or topic here to start exploring. Use the filters to narrow results by date range, platform, language, and more.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="dashboard-charts"]',
    title: 'Dashboard Charts',
    content:
      'All your insights appear here as interactive charts — sentiment trends, mention timelines, audience breakdowns and more. Click any chart bar to drill down.',
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '[data-tour="genai-copilot"]',
    title: 'Gen AI CoPilot',
    content:
      'Ask our AI assistant anything about your data. Get instant summaries, key takeaways, and natural-language explanations of what the data means for your brand.',
    placement: 'left',
    disableBeacon: true,
  },
  {
    target: '[data-tour="take-tour-btn"]',
    title: "You're all set!",
    content:
      'You can replay this tour anytime by clicking the "Take a Tour" button at the bottom of the sidebar.',
    placement: 'right',
    disableBeacon: true,
  },
];
